export enum AltConstants {
  SHOT_ITEM_ICON = 'Shop Item Icon',
  SCREEN_FRAME = 'Screen Frame',
  INFO_ICON = 'Info Icon',
  EMOJI_ICON = 'Emoji Icon',
  LOGO_ICON = 'Logo Icon',
  STAR_ICON = 'Star Icon',
  ROOM_PHOTO = 'Room Photo',
  ACTIVE_ROUTE_ICON = 'Active Route Icon',
  NOTIFICATION_ICON = 'Notification Icon',
  CART_ICON = 'Cart Icon',
  DROPDOWN_STATUS_ICON = 'Dropdown Icon',
  STATUS_ICON = 'Status Icon',
  ACTIVE_LEASE_IMAGE = 'Active Booking Image',
  CONGRATULATION_ICON = 'Congratulation',
  LICENSE_ICON = 'License Icon',
  LOCATION_IMAGE = 'Location Image',
  LOCATION_PIN = 'Location Pin',
  ACTION_ICON = 'Action Icon',
  UPLOADED_IMAGE = 'Uploaded Image',
  PLAYLIST_ICON = 'Playlist Icon',
  paymentTypeIcon = 'Payment type Icon',
  PRICE_ICON = 'Price Icon',
}
